const CircleWithCheck = ({ ...props }) => {
    return (
        <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M7 28C7 16.402 16.402 7 28 7C39.598 7 49 16.402 49 28C49 39.598 39.598 49 28 49C16.402 49 7 39.598 7 28Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M36.1663 22.166L24.8826 33.8327L19.833 28.6118"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default CircleWithCheck
